module.exports = __webpack_public_path__ + "img/device_am28.5d36d13b.png";